class Cache {

    constructor() {
        this.caches = window.caches;
    }

    invalidateAll() {
        console.log('invalidate cache');
        if (this.isCacheStorageAvailable()) {
            let caches = this.caches;

            caches.has('exprcrd').then((hasCache) => {
                if (hasCache === true) {
                    console.log('has cache');
                    caches.delete('exprcrd').then((isDeleted) => {
                        if (isDeleted) {
                            console.log('reload page');
                            window.location = window.location;
                        }
                    })
                }
            });
        }
    }

    invalidate(pageUrl, redirectUrl = null, cacheName = 'exprcrd') {
        // console.log('invalidate');
        // if (this.isCacheStorageAvailable()) {
        //     let caches = this.caches;
        //     caches.open(cacheName).then(cache => {
        //         cache.keys().then(function (keyList) {
        //             return Promise.all(keyList.map(function (request) {
        //                 let url = new URL(request.url);
        //                 if (url.pathname === pageUrl) {
        //                     cache.delete(request);
        //                     cache.add(pageUrl);
        //                 }
        //             })).then(() => {
        //                 if (redirectUrl !== null) {
        //                     window.location = redirectUrl;
        //                 }
        //             });
        //         });
        //     });
        // } else {
        //     window.location = redirectUrl;
        // }
    }

    add(pageUrl, cacheName = 'exprcrd') {
        // if (this.isCacheStorageAvailable()) {
        //     let caches = this.caches;
        //     caches.open(cacheName).then(cache => {
        //         cache.add(pageUrl);
        //     });
        // }
    }

    isCacheStorageAvailable() {
        return typeof (this.caches) === 'object' && this.caches instanceof CacheStorage;
    }
}

export default new Cache;